import {Basic} from "./Basic";
import {Slider} from "./Slider";
import {History} from "./History";

export class Lightbox
{
    constructor(html, lastPage, lastTitle)
    {
        let myPadding = document.documentElement.getBoundingClientRect()['width'];
        document.documentElement.classList.add('no-overflow');
        myPadding = document.documentElement.getBoundingClientRect()['width'] - myPadding;
        document.documentElement.style.paddingRight = myPadding.toString() + 'px';
        this.lastPage = lastPage;
        this.lastTitle = lastTitle;

        this.frame = document.createElement('div');
        this.frame.classList.add('lightbox');
        this.frame.classList.add('interactive');
        this.frame.innerHTML = html;
        this.frame.style.transform = 'scale(.1)';
        this.frame.style.opacity = '0';
        document.body.appendChild(this.frame);

        const lbSlider = this.frame.querySelector('.slider-move');
        if(lbSlider)
        {
            Basic.sliders[99] = new Slider(lbSlider,99);
            Basic.sliders[99].moveEl.classList.add('autoscrolling');
            Basic.sliders[99].autoscroll = true;
            setTimeout(() => {
                Basic.sliders[99].autoscrollNow()
            },3000);
        }
        this.frame.offsetHeight;

        const closeButton = document.getElementById('lightbox-close');
        closeButton.href = lastPage;
        closeButton.addEventListener('click',e =>
        {
            e.preventDefault();
            this.close();
        });
        this.show();
    }

    show()
    {
        this.frame.style.transform = 'scale(1)';
        this.frame.style.opacity = '1';
    }

    close()
    {
        this.frame.style.transform = 'scale(.1)';
        this.frame.style.opacity = '0';
        History.push_url(this.lastPage, this.lastTitle,0);
        document.documentElement.classList.remove('no-overflow');
        setTimeout(() => {
           this.frame.remove();
        },500);
    }
}
